import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import { createDndContext, DndProvider } from "react-dnd";
import LibraryService from "../../../../services/LibraryService/LibraryService";
import { HTML5Backend } from "react-dnd-html5-backend";
import AllFlowDrag from "./editAction/AllFlowDrag";
import Grid from "@material-ui/core/Grid";
import Header from "./header/Header";
import RightSideBar from "../../../../components/FlowConfigurationForms";
import AutomService from "../../../../services/AutomService/AutomService";
import "../Autom.css";
import { history, updateHistory } from "../../../../helpers/historyHandler";
import VariableService from "../../../../services/VariableService/VariableService";
import { RepeatComp } from "./component/AutomComponent";
import { useNavigate, useParams } from "react-router-dom";
import LeftSidebar from "./leftSideBar/LeftSideBar";
import ShortCutSection from "./shortCutSection/ShortCutSection";
import Debugger from "./debugger";
import DiagramBuilder from "./DiagramBuilder/DiagramBuilder";
import Roi from "../roi/Roi";

const RNDContext = createDndContext(HTML5Backend);

function useDNDProviderElement(props) {
  const manager = useRef(RNDContext);

  if (!props.children) return null;

  return (
    <DndProvider manager={manager.current.dragDropManager}>
      {props.children}
    </DndProvider>
  );
}

export function DragAndDrop(props) {
  const DNDElement = useDNDProviderElement(props);
  return <React.Fragment>{DNDElement}</React.Fragment>;
}

const DEFAULT = {
  name: "root",
  acceptsNewChildren: true,
  accepts: ["nested", "action"],
  children: [
    {
      id: "01",
      type: "start",
      actionName: "Start",
      accepts: [],
      source: true,
      children: [],
      acceptsNewChildren: false,
      order: 0,
    },
  ],
};

export const DataContext = createContext({
  items: DEFAULT,
  setItems: () => { },
  setSelected: () => { },
  moreSelected: [],
  setMoreSelected: () => { },
  initialFlowItem: [
    {
      type: "STOP",
      actionName: "STOP",
      accepts: [],
      libraryName: "STOP",
      source: true,
      children: [],
      fields: {},
      acceptsNewChildren: false,
      order: 0,
      selected: false,
      isDebugging: false,
      autom_id: null,
    },
  ],
  setInitialFlowItem: () => { },
});

const FlowConfiguration = (props) => {
  const ref = useRef(null);
  let params = useParams();
  const paramsId = params.id;
  const startItems = useContext(DataContext);
  const [items, setItems] = useState(startItems.items);

  const [data, setData] = useState([]);
  const [variableRender, setVariableRender] = useState(true);
  const [open, setOpen] = useState(false);
  const [scale, setScale] = useState(1);
  const [render, setRender] = useState(false);
  const [renderExt, setRenderExt] = useState(false);
  const [selected, setSelected] = useState([]);
  const historyLocation = useNavigate();
  const [variables, setVariables] = useState([]);
  const [isMove, setIsMove] = useState(false);
  const [openVariable, setOpenVariable] = useState(false);
  const [automDetail, setAutomDetail] = useState();
  const [firstRender, setFirstRender] = useState(false);
  const [editAutomRender, setEditAutomRender] = useState(false);
  const [debuggingStart, setDebuggingStart] = useState(false);
  const [debuggingExpand, setDebuggingExpand] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectAutomVersion, setSelectAutomVersion] = useState("");
  const [isDiagramBuilder, setIsDiagramBuilder] = useState(
    !(
      localStorage.getItem("tabs") !== null &&
      localStorage.getItem("tabs") !== undefined &&
      localStorage.getItem("tabs") === "diagram"
    )
  );
  const [diagramData, setIsDiagramData] = useState([]);
  const recorder = useRef([]);
  const drecorder = useRef([]);
  const [openRoi, setOpenRoi] = useState(false);
  const [openRunningModal, setOpenRunningModal] = useState(false);
  const [libraryData, setLibraryData] = useState([]);
  const [groupLabel, setGroupLabel] = useState("");
  const [moreSelected, setMoreSelected] = useState(startItems.moreSelected);
  const [initialFlowItem, setInitialFlowItem] = useState(
    startItems.initialFlowItem
  );
  let droparea = 6;
  let rightbar = 3;
  if (!open || moreSelected.length > 1) {
    droparea = 9;
    rightbar = 0;
  }

  //find the icon of the incoming action
  function editDataImage(item) {
    if (data && data.length) {
      let imageData = data.filter(
        (action) => action.library_name === item?.libraryName
      );
      return imageData && imageData[0]?.image;
    }
  }

  // When data comes from database, set icon and groupable comp.
  function setInitialAction(node) {
    if (node && node?.length > 0) {
      node.map((item) => {
        if (!item?.expandable) {
          item["expandable"] = true;
        }
        if (!item?.main) {
          item["main"] = false;
        }
        if (!item?.autom_id) {
          item["autom_id"] = null;
        }

        if (item.acceptsNewChildren) {
          item["item"] = RepeatComp;
          if (item.type !== "start") {
            item["image"] = editDataImage(item);
          }
          setInitialAction(item.children);
        } else {
          if (item.type !== "start") {
            item["image"] = editDataImage(item);
          }
          item["item"] = "div";
        }
        if (!debuggingStart) {
          item.isDebugging = false;
        }
        return item;
      });
    }
    return node;
  }

  async function SetInitialData() {
    items.children.splice(1, items.children.length - 1);
    setItems(items);
    let ls = sessionStorage.getItem("flow");
    let lsDiagram = localStorage.getItem("diagram");
    let stopAction = JSON.parse(sessionStorage.getItem("stopAction"));
    ls = setInitialAction(JSON.parse(ls));
    if (ls !== null) {
      history.future = [];
      history.past = [];
      history.present = [];
      if (stopAction !== null) {
        setInitialFlowItem([stopAction]);
      }
      items.children.splice(1, items.children.length - 1);
      ls.splice(0, 1);
      items.children.push(...ls);
      setItems(items);
      lsDiagram !== null && setIsDiagramData(lsDiagram);
      const response = await AutomService.getAutomsById(paramsId);
      // if the autom is not active, go to the autom list page
      if (response.data.status !== 1) {
        historyLocation("/automs");
      }
      if (response) {
        setAutomDetail(response.data);
        setSelectAutomVersion(response.data.versionId);
        if (response?.data?.integration_type === "TRIGGER") {
          await automaticallyVariableCreation(response?.data?.trigger_type);
        }
        setLoading(true);
      }
    } else {
      const response = await AutomService.getAutomsById(paramsId);
      // if the autom is not active, go  to the autom list page
      if (response.data.status !== 1) {
        historyLocation("/automs");
      }
      if (response.data?.id === paramsId) {
        if (response.data.diagram && response.data.diagram !== null) {
          setIsDiagramData(response.data.diagram);
          localStorage.setItem("diagram", response.data.diagram);
        }
        setAutomDetail(response.data);
        setSelectAutomVersion(response.data.versionId);
        setLoading(true);
        if (response?.data?.integration_type === "TRIGGER") {
          await automaticallyVariableCreation(response?.data?.trigger_type);
        }
        if (response.data.flow) {
          let results = setInitialAction(response.data.flow);
          if (results[results.length - 1].actionName === "STOP") {
            const stopAction = results[results.length - 1];
            setInitialFlowItem([stopAction]);
          }
          results.pop();
          history.future = [];
          history.past = [];
          items.children.splice(1, items.children.length - 1);
          items.children.push(...results);
          setItems(items);
        } else {
          items.children.splice(1, items.children.length - 1);
          setItems(items);
          history.future = [];
          history.past = [];
          history.present = [];
        }
      } else {
        historyLocation("/");
      }
      updateHistory("flow", items);
    }
  }

  useEffect(async () => {
    await allGetLibrary();
    setFirstRender(true);
  }, [renderExt]);
  useEffect(async () => {
    if (firstRender) {
      await SetInitialData();
      setFirstRender(false);
      let tabsSelected = localStorage.getItem("tabs");
      if (tabsSelected !== null && tabsSelected !== undefined) {
        tabsSelected === "diagram"
          ? setIsDiagramBuilder(false)
          : setIsDiagramBuilder(true);
      }
    }
  }, [firstRender, data]);

  useEffect(() => {
    if (variableRender) {
      VariableService.getVariable(selectAutomVersion).then((response) => {
        setVariables(response.data);
        setVariableRender(false);
      });
    }
  }, [variableRender]);

  async function allGetLibrary() {
    const response = await LibraryService.getAllLibrary();
    if (response) {
      if (response?.status) {
        const filteredAutomLibrary = response.data.filter(
          (item) => item.module_name === "AUTOMS"
        );
        const recorders = filteredAutomLibrary[0].libraries.find(
          (item) => item.library_name === "RECORDER"
        );
        const drecorders = filteredAutomLibrary[0].libraries.find(
          (item) => item.library_name === "DESKTOP-ACTIONS"
        );
        for (const item of drecorders.actions) {
          item.image = drecorders.image;
          item.actionName = item.action_name;
          item.libraryName = drecorders.library_name;
          item.children = [item.action_name];
          item.source = false;
          item.item = "div";
        }
        for (const item of recorders.actions) {
          item.image = recorders.image;
          item.actionName = item.action_name;
          item.libraryName = recorders.library_name;
          item.children = [item.action_name];
          item.source = false;
          item.item = "div";
        }
        recorder.current = recorders.actions;
        drecorder.current = drecorders.actions;
        setData(filteredAutomLibrary[0].libraries);
        setLibraryData(response.data);
      }
    }
  }

  //A new variable will be created when a new trigger flow added.
  async function automaticallyVariableCreation(triggerType) {
    const response = await VariableService.getVariable(selectAutomVersion);

    //if integration type is a trigger and We search the
    //variable data, if the name is "trigger Param" we return true otherwise false
    let responseData = false;
    if (triggerType?.split(",")?.includes("webhook") || triggerType?.split(",")?.includes("api")) {
      let filter = response?.data?.some((item) => item.name === "triggerParam");
      if (!filter) {
        const data = {
          name: "triggerParam",
          type: "object",
          type_id: "f1ff5b71-cf84-402b-b73c-eb4e399790b9",
          description: "",
          is_input: 0,
          is_output: 0,
          is_customizable: 0,
          autom_version_id: selectAutomVersion,
        };
        const resp = await VariableService.postVariable(data);
        if (resp) {
          responseData = true;
        }
      }
    }
    if (responseData) {
      setVariableRender(true);
    }
  }

  useEffect(async () => {
    if (editAutomRender) {
      const response = await AutomService.getAutomsById(paramsId);

      setAutomDetail(response.data);
      setEditAutomRender(false);
    }
  }, [editAutomRender]);

  const changeScale = (e, action) => {
    if (action === "zoom-in" && scale < 1) {
      setScale(scale + 0.15);
    } else if (action === "zoom-out" && scale > 0.35) {
      setScale(scale - 0.15);
    }
  };

  return (
    <DragAndDrop>
      <DataContext.Provider
        value={{
          items,
          setItems,
          setSelected,
          initialFlowItem,
          setInitialFlowItem,
          setMoreSelected,
          moreSelected,
        }}
      >
        <Grid container spacing={2} id="content-area">
          {isDiagramBuilder && (
            <Grid item xs={5} sm={3} md={3} lg={3}>
              <LeftSidebar
                setVariableRender={setVariableRender}
                id={paramsId}
                changeScale={changeScale}
                selectedItem={selected}
                setOpen={setOpen}
                open={open}
                setOpenVariable={setOpenVariable}
                openVariable={openVariable}
                data={data}
                setData={setData}
                setVariables={setVariables}
                variables={variables}
                render={render}
                setRender={setRender}
                libraryData={libraryData}
              />
            </Grid>
          )}
          <Grid
            item
            xs={isDiagramBuilder ? droparea - 2 : 12}
            sm={isDiagramBuilder ? droparea : 12}
            md={isDiagramBuilder ? droparea : 12}
            lg={isDiagramBuilder ? droparea : 12}
            className="middle-area"
          >
            <div id="alt-area">
              <Grid item className="flowTopNav">
                <Header
                  variables={variables}
                  automDetail={automDetail}
                  setAutomDetail={setAutomDetail}
                  setRender={setRender}
                  selectAutomVersion={selectAutomVersion}
                  setSelectAutomVersion={setSelectAutomVersion}
                  setFirstRender={setEditAutomRender}
                  automaticallyVariableCreation={automaticallyVariableCreation}
                  debuggingStart={debuggingStart}
                  setDebuggingStart={setDebuggingStart}
                  setInitialAction={setInitialAction}
                  setIsDiagramBuilder={setIsDiagramBuilder}
                  diagramData={diagramData}
                  openRunningModal={openRunningModal}
                  setOpenRunningModal={setOpenRunningModal}
                  setOpenVariable={setOpenVariable}
                />
              </Grid>

              {!isDiagramBuilder ? (
                <div style={{ width: "100%", position: "fixed", top: "100px" }}>
                  <DiagramBuilder
                    isDiagramBuilder={isDiagramBuilder}
                    diagramData={diagramData}
                    setDiagramData={setIsDiagramData}
                    setIsDiagramBuilder={setIsDiagramBuilder}
                    setOpenRoi={setOpenRoi}
                  />
                </div>
              ) : (
                <Grid
                  item
                  className="flow-main"
                  style={{ height: debuggingStart ? "85vh" : "auto" }}
                >
                  <Grid item>
                    <ShortCutSection
                      changeScale={changeScale}
                      selectedItem={selected}
                      setRender={setRender}
                      isDebugging={debuggingStart}
                      isDebuggingExpand={debuggingExpand}
                    />
                  </Grid>
                  {loading ? (
                    <Grid item xs={12} sm={12} md={12} lg={12} id="all-flow">
                      <AllFlowDrag
                        setIsMove={setIsMove}
                        isMove={isMove}
                        libraryData={data}
                        setRender={setRender}
                        render={render}
                        items={items}
                        debuggingStart={debuggingStart}
                        scale={scale}
                        setOpen={setOpen}
                        setIsDiagramBuilder={setIsDiagramBuilder}
                        setOpenRoi={setOpenRoi}
                        groupLabel={groupLabel}
                        open={open}
                      />
                    </Grid>
                  ) : (
                    <div className="flow-loading"> Loading ... </div>
                  )}
                  {loading && !open && (
                    <Grid>
                      <div className="open-menu">
                        <ArrowLeftIcon
                          onClick={() => setOpen(!open)}
                          ref={ref}
                          style={{
                            color: "#959595",
                            marginTop: "6px",
                            pointerEvents: items.children.length < 2 && "none",
                          }}
                        />
                      </div>
                    </Grid>
                  )}
                </Grid>
              )}

              {isDiagramBuilder && debuggingStart && (
                <Debugger
                  openRunningModal={openRunningModal}
                  setDebuggingExpand={setDebuggingExpand}
                />
              )}
            </div>
          </Grid>
          {isDiagramBuilder && (
            <Grid
              item
              xs={rightbar > 0 ? rightbar : false}
              sm={rightbar > 0 ? rightbar : false}
              md={rightbar > 0 ? rightbar : false}
              lg={rightbar > 0 ? rightbar : false}
              id="right-area"
            >
              {items && (
                <RightSideBar
                  setGroupLabel={setGroupLabel}
                  selectedAction={selected}
                  mateId={automDetail?.mate_id}
                  setSelected={setSelected}
                  variables={variables}
                  setOpenVariable={setOpenVariable}
                  variableRender={variableRender}
                  automId={paramsId}
                  automVersionId={selectAutomVersion}
                  recorder={recorder}
                  setRender={setRenderExt}
                  drecorder={drecorder}
                  setOpen={setOpen}
                />
              )}
            </Grid>
          )}
          {openRoi && <Roi setOpen={setOpenRoi} />}
        </Grid>
      </DataContext.Provider>
    </DragAndDrop>
  );
};

export default FlowConfiguration;
